import React from "react";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";
import NewUnitForm from "../../components/NewUnitForm";
import { useNavigate, useParams } from "react-router-dom";

const MobileEditUnit = () => {
  const navigate = useNavigate();

  const { id: selectedUnitId } = useParams<{
    id: string;
    prop_id: string;
  }>();

  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      <div className="mb-4">
        <MobileSecViewsHeader title={"Editar Unidad"} route={"/units"} />
      </div>
      <NewUnitForm
        setShowForm={() => {}}
        extraFunc={() => navigate(`/units`)}
        isMobile={true}
        selectedUnitDocumentId={selectedUnitId}
      />
    </div>
  );
};

export default MobileEditUnit;
